<button
  type="button"
  class="text-{{buttonStyle() || type().style}}"
  [class.transparent]="transparent()"
  [disabled]="disabled()"
  [title]="description() || label() || type().label"
  [attr.aria-label]="description() || label() || type().label"
  (click)="onClick($event)"
>
  <icon [type]="icon() || type().icon"></icon>
  @if (!transparent()) {
    {{ label() || type().label }}
  }
</button>
